import type { ReactNode } from 'react'
import { Icon, type IconName } from '../../components/icons/Icon'
import { HelpBalloon } from '../../help/HelpBalloon'
import type { HelpContentId } from '../../help/helpContent'

export interface PageHeaderPrimaryAction {
  label: string
  onClick: () => void
  icon?: IconName
}

export interface PageHeaderProps {
  icon: IconName
  title: string
  countLabel?: string | undefined
  primaryAction?: PageHeaderPrimaryAction | undefined
  secondaryActions?: ReactNode | undefined
  /** Optional — renders a contextual `HelpBalloon` next to the page title (roadmap #12). */
  helpId?: HelpContentId | undefined
}

export function PageHeader({ icon, title, countLabel, primaryAction, secondaryActions, helpId }: PageHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--iw-space-3)',
        flexWrap: 'wrap',
        padding: 'var(--iw-space-4) var(--iw-space-5)',
        borderBottom: '1px solid var(--iw-border)',
        background: 'var(--iw-surface)',
      }}
    >
      <span style={{ color: 'var(--iw-accent)', display: 'inline-flex' }}>
        <Icon name={icon} size={20} />
      </span>
      <h1 style={{ fontSize: 'var(--iw-size-lg)', margin: 0 }}>{title}</h1>
      {helpId ? <HelpBalloon id={helpId} /> : null}
      {countLabel ? <span className="iw-pill iw-pill--neutral">{countLabel}</span> : null}
      <span style={{ flex: 1 }} />
      {secondaryActions}
      {primaryAction ? (
        <button type="button" className="iw-btn iw-btn--primary" onClick={primaryAction.onClick}>
          {primaryAction.icon ? <Icon name={primaryAction.icon} size={14} /> : null}
          {primaryAction.label}
        </button>
      ) : null}
    </div>
  )
}
